import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {thunk} from 'redux-thunk'; // Correct import statement
import reducer from './reducer'; // Import your root reducer

// Create a persist config
const persistConfig = {
  key: 'root',
  storage,
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, reducer);

// Create the Redux store with the persisted reducer and middleware
const store = createStore(persistedReducer, applyMiddleware(thunk));

// Create a persistor for the store
const persistor = persistStore(store);

export { store, persistor };
